import { uniqBy } from 'lodash';

import type { FilterTableOptionType } from './_filtered-table-types';

function defaultSortByOption<O extends { text?: unknown; label?: unknown }>(
  a: O,
  b: O
): number {
  const aKey = a.text ?? a.label ?? '';
  const bKey = b.text ?? b.label ?? '';
  return String(aKey).localeCompare(String(bKey));
}

function idAndNameToOption(item: {
  id: unknown;
  name: unknown;
}): FilterTableOptionType {
  return {
    text: String(item.name),
    value: item.id as string | number | boolean,
  };
}

export function buildOptionsFromData<
  O extends { text?: unknown; label?: unknown } = FilterTableOptionType,
>(
  data: unknown[] | null | undefined,
  toOption?: (item: any) => O,
  uniqByAttribute?: (item: any) => unknown,
  sortBy?: any
): O[] | undefined {
  if (!Array.isArray(data) || data.length === 0) {
    return;
  }

  const toOpt = toOption ?? (idAndNameToOption as unknown as (item: any) => O);
  const uniqAttr = uniqByAttribute ?? ((item: any) => item?.id);
  const sort = sortBy ?? defaultSortByOption<O>;

  return uniqBy(data, uniqAttr).map(toOpt).sort(sort);
}

export function filtersForPaginatedAttr<
  O extends { text?: unknown; label?: unknown } = FilterTableOptionType,
>(
  data: unknown[] | null | undefined,
  uniqByAttribute: (item: any) => unknown,
  toOption?: (item: any) => O
): O[] | undefined {
  return buildOptionsFromData(data, toOption, uniqByAttribute);
}
